import axios from 'axios';
import router from './router';

export default function (store) {
  axios.interceptors.request.use(
    (config) => {
      const hasToken = store.getters.hasToken();
      const token = store.getters.token();
      if (!hasToken) {
        store.commit('logOut');
        router.push({ name: 'sign-in' });
        return config;
      }
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => {
      console.log('erred');
      return Promise.reject(error);
    },
  );
  axios.interceptors.response.use(
    (response) => { return response; },
    (error) => {
      console.log('err in axios interceptor response');
      console.log(error);
      return Promise.reject(error);
    },
  );
  return axios;
}
